export const getData = async ({
  url,
  data,
  method,
}: {
  method: "GET" | "POST";
  url: string;
  data?: { [key: string]: string };
}) => {
  const req = await fetch(url, {
    method,
    headers: new Headers({ "content-type": "application/json" }),
    body: JSON.stringify(data),
  });

  const reqData = await req.json();

  return {
    ...reqData,
    http_code: req.status,
  };
};
